import api from "../utils/api";

const BASE =
  "/api/traffic-analytics";

function options(params = {}) {
  return {
    params,

    paramsSerializer: {
      indexes: null,
    },
  };
}

export async function getTrafficOverview(
  params = {},
) {
  return (
    await api.get(
      `${BASE}/overview`,
      options(params),
    )
  ).data;
}

export async function getTrafficShops(
  params = {},
) {
  return (
    await api.get(
      `${BASE}/shops`,
      options(params),
    )
  ).data;
}

export async function getTrafficShop(
  shopId,
  params = {},
) {
  return (
    await api.get(
      `${BASE}/shops/${shopId}`,
      options(params),
    )
  ).data;
}

export async function getTrafficVoucher(
  voucherId,
  params = {},
) {
  return (
    await api.get(
      `${BASE}/vouchers/${voucherId}`,
      options(params),
    )
  ).data;
}

export async function getTrafficTimeSeries(
  params = {},
) {
  return (
    await api.get(
      `${BASE}/time-series`,
      options(params),
    )
  ).data;
}

export async function getTrafficApplications(
  params = {},
) {
  return (
    await api.get(
      `${BASE}/applications`,
      options(params),
    )
  ).data;
}

export async function getTrafficCategories(
  params = {},
) {
  return (
    await api.get(
      `${BASE}/categories`,
      options(params),
    )
  ).data;
}

export async function getTrafficCountries(
  params = {},
) {
  return (
    await api.get(
      `${BASE}/countries`,
      options(params),
    )
  ).data;
}

export async function getTrafficFirewalls(
  params = {},
) {
  return (
    await api.get(
      `${BASE}/firewalls`,
      options(params),
    )
  ).data;
}

export async function getTrafficEvents(
  params = {},
) {
  return (
    await api.get(
      `${BASE}/events`,
      options(params),
    )
  ).data;
}